module.exports = __webpack_public_path__ + "2302b73a95fd80d30e73f69587e2706c.svg";